<template>
  <div v-if="item">
    <h2># {{ id }}</h2>
    <div class="border" v-if="item.client">
      <h4>Информация</h4>

      <h5 class="text-info">Статус: {{ item.display_status_transfer }}</h5>

      <h5>
        Сумма оценки:
        <span class="" v-if="item.price"
          >{{ item.price | spaceBetweenNumber }} UZS</span
        >
        <span class="text-danger" v-else>Нет оценки</span>
      </h5>

      <h5>
        Покупаемый товар:
        <span class="" v-if="item.price_purchase"
          >{{ item.name_purchase }} / {{ item.brand_purchase }} /
          {{ item.imei_purchse }} /
          {{ item.price_purchase | spaceBetweenNumber }} UZS</span
        >
        <span class="text-danger" v-else>Товар не установлен</span>
      </h5>

      <h5>
        Контактный номер клиента:
        <span class="">{{ item.client.phone }}</span>
      </h5>

      <hr />
      <div>
        <h5 v-for="(datum, key) in details" :key="key">
          {{ datum.label }}:
          <span v-if="item[datum['key']]">
            <span v-if="datum.dateFormat" class="">{{
              item[datum["key"]] | dateFormat
            }}</span>
            <span v-else class="">{{ item[datum["key"]] }}</span>
          </span>
          <span v-else>Не заполнено</span>
        </h5>
      </div>

      <div class="mt-4">
        <button @click="cancelRequest" class="btn btn-danger mw">
          Отменить заявку
        </button>
      </div>
    </div>

    <div class="border">
      <h4>Процесс</h4>
      <div v-if="item.price > 0 && item.price_purchase > 0">
        <div>
          <div class="mb-4 mt-4">
            <h5 class="text-bold">1. Скачайте договор</h5>
            <a
              ref="downloadDoc"
              target="_blank"
              class="btn btn-info mr-2"
              :href="`${$store.state.host}/api/v1/pdf/trade_ins/${item.id}`"
              >Скачать договор (RU)</a
            >
            <a
              ref="downloadDoc"
              target="_blank"
              class="btn btn-info"
              :href="`${$store.state.host}/api/v1/pdf/trade_ins/${item.id}?localization=uz`"
              >Скачать договор (UZ)</a
            >
          </div>
          <hr />

          <div class="mb-4 mt-4">
            <h5 class="text-bold">
              2. Распечатайте и попросите клиента подписать договор
            </h5>
          </div>
          <hr />
          <div class="mb-2">
            <h5 class="text-bold">
              3. Загрузите подписанный договор в систему
            </h5>
            <zip-upload
              v-model="item.photo_document_sign"
              :title="'Выберите PNG/JPG/PDF'"
              @input="updateItemData(['photo_document_sign'], [])"
            />
          </div>
          <hr />
          <div class="mb-4 mt-4">
            <h5 class="text-bold">4. Упакуйте товар в сейф-пакет</h5>
          </div>

          <hr />

          <div
            :class="`mb-4 mt-4 ${
              item.status_transfer !== 'new' || !item.photo_document_sign
                ? 'opacity'
                : ''
            }`"
          >
            <h5 class="text-bold">5. Отсканируйте штрих-код на сейф-пакете</h5>

            <div class="row">
              <div class="col-12 col-md-6">
                <fg-input
                  :type="`text`"
                  :label="`Введите штрих-код`"
                  :labelKey="`input_limit`"
                  v-model="data.code"
                ></fg-input>
              </div>
            </div>
            <button
              @click="updateItemData(['code'], ['code'])"
              class="btn btn-info btn-icon mw mt-1"
            >
              {{ "apply" | setText("Применить") }}
            </button>

            <h5 class="mt-3 text-success" v-if="item.code">
              Штрих-код установлен: {{ item.code }}
            </h5>
          </div>
          <hr />
          <div
            :class="`mb-4 mt-4 ${
              item.status_transfer !== 'new' ||
              !item.code ||
              !item.photo_document_sign
                ? 'opacity'
                : ''
            }`"
          >
            <h5 class="text-bold">
              6. Убедитесь, что сделали все правильно - нажмите завершить
            </h5>
            <button
              @click="
                updateItemData(['status_transfer'], ['status_transfer'], true)
              "
              class="btn btn-info btn-icon mw mt-1"
            >
              {{ "done" | setText("Завершить") }}
            </button>
          </div>
        </div>
      </div>

      <div v-else-if="item.price > 0">
        <h5 class="text-bold">Выберите новый смартфон</h5>
        <a class="btn btn-info" target="_blank" :href="'/#/orders'"
          >Создать заказ</a
        >
      </div>
      <div v-else>
        <h5 class="text-bold">Сформируйте заявку в системе TRADE-IN</h5>
        <trade-in :data="item" />
      </div>
    </div>

    <div class="border">
      <h4>Детали</h4>
      <fields-list :simple="true" :item="item" :fields="fields" />
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>

<script>
import {
  cardUpdate,
  cardContent,
  pushLang,
  errorNotify,
  toFormData,
} from "@/plugins/functions";
import TradeIn from "@/components/Services/trade-in";

export default {
  components: { TradeIn },
  data: () => ({
    cardLink: "trade_ins",
    cardSetLink: "trade_ins",
    item: null,
    fields: [
      // {
      //   label: "Договор (подписанный)",
      //   key: "photo_document_sign",
      //   type: "zip",
      // },
      {
        col: "col-12 col-md-6",
        label: "Имя",
        key: "first_name",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Фамилия",
        key: "last_name",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Отчество",
        key: "family_name",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Дата договора",
        key: "date",
        type: "field",
        textType: "date",
      },
      {
        col: "col-12 col-md-6",
        label: "Фото передней стороны устройства (хорошее качество)",
        key: "photo_device_front",
        type: "img",
      },
      {
        col: "col-12 col-md-6",
        label: "Фото задней стороны устройства (хорошее качество)",
        key: "photo_device_back",
        type: "img",
      },
      {
        col: "col-12 col-md-6",
        label: "Фото боковой стороны устройства (хорошее качество)",
        key: "photo_device_side",
        type: "img",
      },
    ],
    details: [
      {
        col: "col-12 col-md-6",
        label: "Устройство",
        key: "name",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "IMEI 1",
        key: "imei",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Бренд",
        key: "brand",
        type: "field",
      },

      {
        col: "col-12 col-md-6",
        label: "ПИНФЛ",
        key: "PINFL",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Номер паспорта",
        key: "passport_number",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Кем выдан паспорт",
        key: "passport_issued",
        type: "field",
      },

      {
        col: "col-12 col-md-6",
        label: "Срок паспорта",
        key: "passport_exp",
        type: "field",
        textType: "date",
        dateFormat: true,
      },
      {
        label: "Адрес",
        key: "passport_address",
        type: "field",
      },
    ],
    data: {
      code: null,
      status_transfer: "process",
    },
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },

  computed: {},

  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );

      if (item && item.id) {
        this.item = item;
      }
    },

    close() {
      let query = Object.assign({}, this.$route.query);

      if (query["item_order_service"]) {
        delete query["item_order_service"];
      }
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },

    async updateItemData(keys = [], newKeys = [], isClose = false) {
      let data = {};
      let tempData = this.item;

      if (newKeys.length) {
        for (let i = 0; i < newKeys.length; i++) {
          let val = this.data[newKeys[i]];

          if (val === true) {
            val = 1;
          } else if (val === false) {
            val = 0;
          }

          data[newKeys[i]] = val;
        }
      } else {
        for (let i = 0; i < keys.length; i++) {
          let val = tempData[keys[i]];
          if (val === true) {
            val = 1;
          } else if (val === false) {
            val = 0;
          }

          data[keys[i]] = val;
        }
      }

      this.$loading(true);
      this.$http({
        method: "post",
        data: toFormData({
          _method: "put",
          ...data,
        }),
        url: `${this.cardLink}/${this.id}`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.$store.dispatch("setLastUpdate", new Date());
          this.item = response.data.data;

          if (isClose) {
            this.close();
          }
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    async cancelRequest() {
      this.$loading(true);
      this.$http({
        method: "put",
        data: {
          status_transfer: "cancel",
        },
        url: `${this.cardLink}/${this.id}`,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.$store.dispatch("setLastUpdate", new Date());
          this.item = response.data.data;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>